import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api, fmt, fmtDate, usdHint } from '../api';
import { Loading, ErrorBox, Empty, KelvinDot } from '../ui';

const TABS = [
  { key: 'pass', label: 'Pasport' },
  { key: 'invoice', label: 'Narxlar tarixi' },
  { key: 'box', label: 'Korobka tarixi' },
  { key: 'orders', label: 'Zakazlar' },
  { key: 'sale', label: 'Sotuv narxlari' },
];

export default function ProductCard() {
  const { id } = useParams();
  const [p, setP] = useState<any>(null);
  const [hist, setHist] = useState<any>(null);
  const [err, setErr] = useState('');
  const [tab, setTab] = useState('pass');

  const load = () => {
    setErr('');
    api.get('/products/' + id).then(setP).catch((e) => setErr(e.message));
    api.get(`/products/${id}/price-history`).then(setHist).catch(() => {});
  };
  useEffect(() => { load(); }, [id]);
  if (err) return <ErrorBox text={err} onRetry={load} />;
  if (!p) return <Loading />;

  const count = {
    invoice: hist?.rows?.length ?? 0,
    box: p.boxHistory?.length ?? 0,
    orders: p.orders?.length ?? 0,
    sale: (p.productPrices?.length ?? 0) || (p.salePrice ? 1 : 0),
  };

  return (
    <div>
      <div className="page-head">
        <div>
          <h1 className="page-title" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <KelvinDot text={p.name} />{p.name}
          </h1>
          <p className="page-sub">
            <span className="code">{p.article}</span>
            {p.altArticle ? <> ↔ <span className="code">{p.altArticle}</span></> : null}
            {' · '}{p.brand?.name || '—'}{' · '}Guruh: {p.customsGroup?.name || "yo'q"}
          </p>
        </div>
        <Link className="btn" to="/products">← Katalog</Link>
      </div>

      <div className="tabs">
        {TABS.map((t) => {
          const n = (count as any)[t.key];
          return (
            <button key={t.key} className={'tab' + (tab === t.key ? ' active' : '')} onClick={() => setTab(t.key)}>
              {t.label}{n ? <span className="muted" style={{ marginLeft: 6 }}>{n}</span> : null}
            </button>
          );
        })}
      </div>

      {/* ── Pasport ── */}
      {tab === 'pass' && (
        <div className="grid-2">
          <div className="card">
            <h3 style={{ marginTop: 0 }}>Asosiy</h3>
            <table><tbody>
              <tr><td className="muted">Quvvat</td><td><span style={{ display: 'inline-flex', alignItems: 'center', gap: 7 }}><KelvinDot text={p.powerLabel} />{p.powerLabel || '—'}</span></td></tr>
              <tr><td className="muted">Kategoriya</td><td>{p.category?.name || '—'}</td></tr>
              <tr><td className="muted">Birlik</td><td>{p.unit === 'pcs' ? 'dona' : p.unit === 'm' ? 'metr' : 'komplekt'}</td></tr>
              <tr><td className="muted">Rastamojka guruhi</td><td>{p.customsGroup?.name || <span className="badge b-cancelled">yo'q</span>}</td></tr>
              <tr><td className="muted">TNVED</td><td className="code">{p.customsGroup?.tnved || '—'}</td></tr>
              <tr><td className="muted">Zavod (CN)</td><td>{p.supplierNameCn || '—'}</td></tr>
            </tbody></table>
          </div>
          <div className="card">
            <h3 style={{ marginTop: 0 }}>O'lcham va og'irlik</h3>
            <table><tbody>
              <tr><td className="muted">Korobkada</td><td>{p.boxQty ? fmt(p.boxQty) + ' dona' : '—'}</td></tr>
              <tr><td className="muted">Korobka brutto</td><td>{p.boxGrossKg ? fmt(p.boxGrossKg, 2) + ' kg' : '—'}</td></tr>
              <tr><td className="muted">Korobka hajmi</td><td>{p.boxM3 ? fmt(p.boxM3, 5) + ' m³' : '—'}</td></tr>
              <tr><td className="muted">1 dona og'irligi</td><td>{p.unitNetKg ? fmt(Number(p.unitNetKg) * 1000, 1) + ' g' : '—'}</td></tr>
              <tr><td className="muted">1 dona hajmi</td><td>{p.unitM3 ? fmt(Number(p.unitM3) * 1e6, 0) + ' cm³' : '—'}</td></tr>
              <tr><td className="muted">1 mesta (fakt)</td><td>{p.mestaKgFact ? fmt(p.mestaKgFact, 2) + ' kg' : '—'}{p.mestaM3Fact ? ' · ' + fmt(p.mestaM3Fact, 4) + ' m³' : ''}</td></tr>
            </tbody></table>
          </div>
        </div>
      )}

      {/* ── Invoys narxlar ── */}
      {tab === 'invoice' && (
        <>
          {(() => {
            // Asosiy ko'rsatkich — prixod narxi (so'm). Invoys narxi bojxona qiymati.
            const px = (hist?.rows || []).map((r: any) => r.prixodPriceUzs).filter((v: any) => v != null).map(Number);
            if (!px.length) return null;
            const first = px[0], last = px[px.length - 1], max = Math.max(...px);
            const chg = first ? ((last - first) / first) * 100 : 0;
            return (
              <div className="stat-grid" style={{ marginBottom: 16 }}>
                <div className="stat accent"><div className="k">Oxirgi prixod narxi</div><div className="v">{fmt(last, 2)}</div><div className="d">so'm · 1 dona uchun</div></div>
                <div className="stat"><div className="k">Eng yuqori prixod</div><div className="v">{fmt(max, 2)}</div><div className="d">butun tarix bo'yicha</div></div>
                <div className="stat ok"><div className="k">Shartnoma bera olamiz</div><div className="v">{fmt(max * 1.1 * 1.12, 2)}</div><div className="d">eng yuqori × 1,1 × 1,12</div></div>
                <div className={'stat' + (chg > 0 ? ' danger' : chg < 0 ? ' ok' : '')}>
                  <div className="k">O'zgarish</div>
                  <div className="v">{chg > 0 ? '+' : ''}{fmt(chg, 1)}%</div>
                  <div className="d">birinchidan oxirgigacha</div>
                </div>
              </div>
            );
          })()}
          {!hist?.rows?.length ? <Empty text="Hali rastamojka tarixi yo'q" hint="Rastamojka hujjati tasdiqlangach narx shu yerga tushadi" /> : (
            <div className="table-wrap">
              <table>
                <thead><tr><th>#</th><th>Sana</th><th>GTD</th><th>Zavod</th><th className="num">Miqdor</th><th className="num">Prixod narxi (so'm)</th><th className="num">Shartnoma bera olamiz</th><th className="num">Invoys narx</th></tr></thead>
                <tbody>
                  {hist.rows.map((r: any, i: number) => (
                    <tr key={r.id}>
                      <td>{i + 1}</td><td>{fmtDate(r.date)}</td><td className="code">{r.gtdNumber || '—'}</td><td>{r.supplierName || '—'}</td>
                      <td className="num">{fmt(r.qty)}</td>
                      <td className="num" style={{ fontWeight: 700 }}>{r.prixodPriceUzs ? fmt(r.prixodPriceUzs, 2) : <span className="muted">—</span>}</td>
                      <td className="num" style={{ fontWeight: 700, color: 'var(--accent)' }}>
                        {r.prixodPriceUzs ? fmt(Number(r.prixodPriceUzs) * 1.1 * 1.12, 2) : <span className="muted">—</span>}
                      </td>
                      <td className="num muted">{fmt(r.invoicePrice, 4)} {r.currency}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* ── Korobka tarixi ── */}
      {tab === 'box' && (
        <>
          <p className="muted" style={{ marginTop: 0 }}>
            Zavod korobkani vaqt o'tib o'zgartiradi. Zakazda tuzatilsa — katalog avtomatik yangilanadi va bu yerga yozuv tushadi.
            Eski hujjatlarning hisobi o'zgarmaydi.
          </p>
          {!p.boxHistory?.length ? <Empty text="Hali o'zgarish bo'lmagan" /> : (
            <div className="table-wrap">
              <table>
                <thead><tr><th>Sana</th><th>Manba</th><th className="num">Korobkada</th><th className="num">Korobka kg</th><th className="num">Korobka m³</th><th>Izoh</th></tr></thead>
                <tbody>
                  {p.boxHistory.map((h: any) => {
                    const arrow = (oldV: any, newV: any, dec: number) => {
                      if (oldV == null) return <span>{fmt(newV, dec)}</span>;
                      if (Math.abs(Number(oldV) - Number(newV)) < 1e-9) return <span className="muted">{fmt(newV, dec)}</span>;
                      const up = Number(newV) > Number(oldV);
                      return <span><span className="muted">{fmt(oldV, dec)}</span> → <span className={up ? 'up' : 'down'}>{fmt(newV, dec)}</span></span>;
                    };
                    return (
                      <tr key={h.id}>
                        <td>{fmtDate(h.changedAt)}</td>
                        <td><span className="badge b-draft">{h.source === 'order' ? 'Zakaz' : h.source === 'contract' ? 'Shartnoma' : h.source === 'import' ? 'Import' : "Qo'lda"}</span></td>
                        <td className="num">{arrow(h.oldBoxQty, h.boxQty, 0)}</td>
                        <td className="num">{arrow(h.oldBoxGrossKg, h.boxGrossKg, 2)}</td>
                        <td className="num">{arrow(h.oldBoxM3, h.boxM3, 5)}</td>
                        <td className="muted">{h.note || '—'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* ── Zakazlar ── */}
      {tab === 'orders' && (
        !p.orders?.length ? <Empty text="Bu mahsulot hali zakaz qilinmagan" /> : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Zakaz</th><th>Zavod</th><th>Sana</th><th className="num">Zavod narxi</th></tr></thead>
              <tbody>
                {p.orders.map((oi: any) => (
                  <tr key={oi.id}>
                    <td><Link to={'/orders/' + oi.order.id} className="code" style={{ color: 'var(--accent)' }}>{oi.order.number}</Link></td>
                    <td>{oi.order.supplier?.name || '—'}</td>
                    <td>{fmtDate(oi.order.orderDate)}</td>
                    <td className="num">
                      {oi.factoryPrice ? <>{fmt(oi.factoryPrice, 2)} {oi.currency || ''}
                        {usdHint(oi.factoryPrice, oi.currency, 3) && <span className="muted" style={{ marginLeft: 6, fontSize: 11.5 }}>{usdHint(oi.factoryPrice, oi.currency, 3)}</span>}
                      </> : <span className="muted">—</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}

      {/* ── Sotuv narxlari ── */}
      {tab === 'sale' && (
        <div className="card">
          <h3 style={{ marginTop: 0 }}>Sotuv narxlari</h3>
          <table><tbody>
            <tr><td className="muted">Sotuv narxi (USD)</td><td style={{ fontWeight: 700 }}>{p.salePrice?.saleUsd ? '$' + fmt(p.salePrice.saleUsd, 2) : '—'}</td></tr>
            <tr><td className="muted">Plan narxi (so'm)</td><td>{p.salePrice?.planUzs ? fmt(p.salePrice.planUzs) : '—'}</td></tr>
            <tr><td className="muted">Shartnoma narxi (so'm)</td><td>{p.salePrice?.contractUzs ? fmt(p.salePrice.contractUzs) : '—'}</td></tr>
          </tbody></table>
          <p className="muted" style={{ fontSize: 12.5, marginBottom: 0 }}>
            Narxlarni <Link to="/prices" className="link">Narxlar</Link> bo'limida tahrirlash mumkin.
          </p>
        </div>
      )}
    </div>
  );
}
